import {useEffect, useState} from 'react'
import {QueryStatus, QueryStatusType} from 'src/types'
import {OperacionTransferenciaTerceros} from "../types/types";
import {HttpTransferenciaTerceros} from "../api/httpTransferenciaTerceros";

type UseOperacionResult<TOperacion> = {
  status: QueryStatusType
  operacion: TOperacion | undefined
}

export const useOperacionTransferenciaTerceros: (idOperacion: number) => UseOperacionResult<OperacionTransferenciaTerceros> = (idOperacion: number) => {
  const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
  const [operacion, setOperacion] = useState<OperacionTransferenciaTerceros>()

  useEffect(() => {
    setStatus(QueryStatus.Loading)

    HttpTransferenciaTerceros.get(idOperacion)
      .then(data => {
        setOperacion(data)
        setStatus(QueryStatus.Success)
      })
      .catch(() => setStatus(QueryStatus.Error))
  }, [idOperacion])

  return {status, operacion}
}
